import { createFileRoute } from "@tanstack/react-router";
import { useContent } from "@/lib/use-content";
import aboutImg from "@/assets/about-hall.jpg";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "אודות | ישיבת תורת חיים" },
      { name: "description", content: "אודות ישיבת תורת חיים - מסגרת תורנית ייחודית לבחורים יראי שמיים." },
    ],
  }),
  component: About,
});

function About() {
  const c = useContent("about");
  return (
    <>
      <section className="bg-primary text-primary-foreground py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="mx-auto mb-4 h-px w-16 bg-gold" />
          <h1 className="font-display text-5xl font-bold">{c.title}</h1>
          <p className="mt-3 text-xl text-gold font-display">{c.subtitle}</p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="space-y-5 text-lg leading-relaxed text-foreground/85">
          {c.paragraphs.map((p: string, i: number) => <p key={i}>{p}</p>)}
        </div>
      </section>

      <section className="bg-secondary py-16">
        <div className="container mx-auto px-4 max-w-4xl grid gap-10 md:grid-cols-2">
          <div>
            <div className="mb-3 h-px w-12 bg-gold" />
            <h2 className="font-display text-3xl font-bold text-primary">{c.forWhomTitle}</h2>
            <p className="mt-4 text-foreground/85 leading-relaxed italic">{c.forWhomText}</p>
          </div>
          <div>
            <div className="mb-3 h-px w-12 bg-gold" />
            <h2 className="font-display text-3xl font-bold text-primary">{c.pathTitle}</h2>
            <p className="mt-4 text-foreground/85 leading-relaxed">{c.pathText}</p>
          </div>
        </div>
      </section>

      <section className="container mx-auto px-4 py-20">
        <div className="text-center mb-12">
          <div className="mx-auto mb-3 h-px w-12 bg-gold" />
          <h2 className="font-display text-4xl font-bold text-primary">{c.journeyTitle}</h2>
          <p className="mt-2 text-muted-foreground">{c.journeySubtitle}</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
          {c.journey?.map((step: any, i: number) => (
            <div key={i} className="relative rounded-lg bg-card shadow-card border border-border/50 hover:shadow-elegant transition-shadow overflow-hidden">
              {step.image && (
                <img src={step.image} alt={step.title} className="w-full h-40 object-cover" loading="lazy" />
              )}
              <div className="p-6 relative">
                <div className="absolute -top-4 right-6 flex h-10 w-10 items-center justify-center rounded-full gradient-gold text-gold-foreground font-display font-bold shadow-card">
                  {i + 1}
                </div>
                <h3 className="mt-2 font-display text-xl font-bold text-primary">{step.title}</h3>
                <p className="mt-3 text-foreground/75 leading-relaxed">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {(c.coverImage || aboutImg) && (
        <section className="container mx-auto px-4 pb-16">
          <img src={c.coverImage || aboutImg} alt="היכל הישיבה" className="rounded-lg shadow-elegant w-full h-auto max-w-5xl mx-auto" loading="lazy" width={1280} height={896} />
        </section>
      )}
    </>
  );
}
